module.exports = __webpack_public_path__ + "static/photoshoot-1-864537e180ea97db772669ab98e00244.jpg";